require('./taskGridController');
require('./taskGridMediator');
require('./taskGrid.tpl.html');
require('./reassign/reassignModalController');
require('./reassign/reassignModal.tpl.html');
require('./reassign/bulkReassignRepository');
require('./resolve/resolveModal.tpl.html');
require('./resolve/resolveModalController');
require('./resolve/bulkResolveRepository');

const TaskGridComponent = {
    templateUrl: '/landing/widget/taskGrid/taskGrid.tpl.html',
    controller: 'taskGridController',
    bindings: {
        widgetConfig: '<',
        filterType: '<'
    }
};

angular.module('umLanding')
    .component('uiTaskGrid', TaskGridComponent);
